import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExchangeRate } from '../models/exchange-rate.model';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class ExchangeRateService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService,
    ) { }

    getExchangeRate(page: number, itemPerPage: number, sorts: SortConfiguration[], codigoMonedaBase: string, codigoMonedaCambio: string, extraParams?: any) {
        const headers = {
            'page-number': String(page),
            'page-size': String(itemPerPage)
        };

        const params: any = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        }

        return this.http.get<ExchangeRate[]>(`/monedas/cambio/${codigoMonedaBase}-${codigoMonedaCambio}`, { headers, observe: 'response', params })
    }

    postExchangeRate(exchangeRate: ExchangeRate) {
        return this.http.post<ExchangeRate>(`/monedas/cambio`, exchangeRate);
    }
}
